import * as React from 'react'
import { IAssistanceCategoryObject, IAssistanceObject } from '../../types/index'
import Modal from '../ui/Modal'
import AddAssistanceCreateForm from './AddAsistanceForm/AddAssistanceCreateForm'

export interface IAssistanceAddModalProps {
  onClose: () => void
  onCreateClick: (assistance: IAssistanceObject) => Promise<any>
  categories: IAssistanceCategoryObject[]
}

interface IAssistanceAddOptionModalState {
  isPending: boolean
  error: string
  newOption: string
}

class AssistanceAddModal extends React.Component<IAssistanceAddModalProps, IAssistanceAddOptionModalState> {
  constructor(props: IAssistanceAddModalProps) {
    super(props)
  }

  public render() {
    const { categories } = this.props

    const currentCategories: any[] = []
    Object.keys(categories).map((item, i) => {
      const value = categories[item].id
      const label = categories[item].name
      currentCategories.push({ label, value })
    })

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='AssistanceModalAddTitle font-small weight-300 font-grey2'>ADD ASSISTANCE</span>
            <AddAssistanceCreateForm
              categories={currentCategories}
              onCancelClick={this.handleCancelClick}
              onCreateClick={this.props.onCreateClick}
            />
          </div>
        </div>
      </Modal>
    )
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }
}

export default AssistanceAddModal



// WEBPACK FOOTER //
// ./src/components/assistance/AssistanceAddModal.tsx